import React from 'react';
import { Card } from '../components/ui/Card';
import { Users, BookOpen, MapPin, Award } from 'lucide-react';
export function DashboardPage() {
  const stats = [{
    label: 'Total Trainings',
    value: '24',
    icon: BookOpen,
    color: 'bg-blue-100 text-blue-600'
  }, {
    label: 'Active Trainers',
    value: '12',
    icon: Users,
    color: 'bg-green-100 text-green-600'
  }, {
    label: 'Venues',
    value: '8',
    icon: MapPin,
    color: 'bg-purple-100 text-purple-600'
  }, {
    label: 'Certificates Issued',
    value: '156',
    icon: Award,
    color: 'bg-orange-100 text-orange-600'
  }];
  return <div className="space-y-6" data-id="element-346">
      <div data-id="element-347">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-348">
          Training Management Overview
        </h3>
        <p className="text-sm text-gray-600 mt-1" data-id="element-349">
          Monitor your training programs and activities
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-350">
        {stats.map(stat => {
        const Icon = stat.icon;
        return <Card key={stat.label} data-id="element-351">
              <div className="flex items-center gap-4" data-id="element-352">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${stat.color}`} data-id="element-353">
                  <Icon className="w-6 h-6" data-id="element-354" />
                </div>
                <div data-id="element-355">
                  <p className="text-sm text-gray-600" data-id="element-356">{stat.label}</p>
                  <p className="text-2xl font-bold text-gray-900" data-id="element-357">
                    {stat.value}
                  </p>
                </div>
              </div>
            </Card>;
      })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-358">
        <Card title="Recent Trainings" data-id="element-359">
          <div className="space-y-3" data-id="element-360">
            <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-361">
              <div data-id="element-362">
                <p className="text-sm font-medium text-gray-900" data-id="element-363">
                  Basic Training - Batch 1
                </p>
                <p className="text-xs text-gray-500" data-id="element-364">Started: 01 Jan 2025</p>
              </div>
              <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded" data-id="element-365">
                Active
              </span>
            </div>
            <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-366">
              <div data-id="element-367">
                <p className="text-sm font-medium text-gray-900" data-id="element-368">
                  Advanced Training - Batch 2
                </p>
                <p className="text-xs text-gray-500" data-id="element-369">Started: 15 Dec 2024</p>
              </div>
              <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded" data-id="element-370">
                Active
              </span>
            </div>
            <div className="flex items-center justify-between py-2" data-id="element-371">
              <div data-id="element-372">
                <p className="text-sm font-medium text-gray-900" data-id="element-373">
                  Specialized Training - Batch 1
                </p>
                <p className="text-xs text-gray-500" data-id="element-374">Completed: 10 Dec 2024</p>
              </div>
              <span className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded" data-id="element-375">
                Completed
              </span>
            </div>
          </div>
        </Card>

        <Card title="Upcoming Sessions" data-id="element-376">
          <div className="space-y-3" data-id="element-377">
            <div className="flex items-center gap-3 py-2 border-b border-gray-100" data-id="element-378">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex flex-col items-center justify-center" data-id="element-379">
                <span className="text-xs text-blue-600 font-medium" data-id="element-380">JAN</span>
                <span className="text-lg font-bold text-blue-600" data-id="element-381">15</span>
              </div>
              <div className="flex-1" data-id="element-382">
                <p className="text-sm font-medium text-gray-900" data-id="element-383">
                  Digital Marketing Fundamentals
                </p>
                <p className="text-xs text-gray-500" data-id="element-384">
                  9:00 AM - 12:00 PM • Online
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 py-2 border-b border-gray-100" data-id="element-385">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex flex-col items-center justify-center" data-id="element-386">
                <span className="text-xs text-blue-600 font-medium" data-id="element-387">JAN</span>
                <span className="text-lg font-bold text-blue-600" data-id="element-388">16</span>
              </div>
              <div className="flex-1" data-id="element-389">
                <p className="text-sm font-medium text-gray-900" data-id="element-390">
                  Business Development Workshop
                </p>
                <p className="text-xs text-gray-500" data-id="element-391">
                  2:00 PM - 5:00 PM • Main Training Center
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 py-2" data-id="element-392">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex flex-col items-center justify-center" data-id="element-393">
                <span className="text-xs text-blue-600 font-medium" data-id="element-394">JAN</span>
                <span className="text-lg font-bold text-blue-600" data-id="element-395">18</span>
              </div>
              <div className="flex-1" data-id="element-396">
                <p className="text-sm font-medium text-gray-900" data-id="element-397">
                  Leadership Training
                </p>
                <p className="text-xs text-gray-500" data-id="element-398">
                  10:00 AM - 1:00 PM • Regional Office
                </p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}